import React from 'react';
import { Flex } from '../../../Flex';
import { InlineAction } from './InlineAction';
export var InlineActionsList = function InlineActionsList(_ref) {
  var actions = _ref.actions,
      rowData = _ref.rowData;
  return /*#__PURE__*/React.createElement(Flex, null, actions.map(function (action, index) {
    return /*#__PURE__*/React.createElement(InlineAction, {
      action: action,
      key: index,
      rowData: rowData
    });
  }));
};